import { SOUND_FILES } from './soundMap'
import { soundManager } from './soundManager'

export const preloadSounds = () => {
  Object.entries(SOUND_FILES).forEach(([name, src]) => {
    soundManager.load(name, src)
  })
}
